import {useEffect} from "react";

const useTabTitle = (title)=>{
    useEffect(()=>{
        document.title = title
    },[])
}

export default useTabTitle